import { Controller } from 'stimulus';
import consumer from "../channels/consumer"

export default class extends Controller {
    connect() {
        this.subscription = consumer.subscriptions.create({
            channel: "PaymentChannel"
        }, {
            received: () => {
                this.load()
            }
        });
    }

    disconnect() {
        this.subscription.unsubscribe();
    }

    load() {
        try {
            Rails.ajax({
                url: "payments.js",
                type: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json"
                },
                dataType: 'json',
                success: () => { }
            })
        } catch (error) {
            console.log(error)
        }
    }
}